var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieLineChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6747 13.573C17.1445 14.8268 16.3153 15.9316 15.2596 16.7908C14.2038 17.65 12.9537 18.2376 11.6184 18.502C10.2831 18.7665 8.90337 18.6998 7.59981 18.3079C6.29624 17.9159 5.10854 17.2106 4.14053 16.2536C3.17253 15.2966 2.4537 14.117 2.04688 12.818C1.64006 11.519 1.55765 10.1401 1.80685 8.80191C2.05605 7.4637 2.62926 6.2069 3.47639 5.1414C4.32351 4.07591 5.41875 3.23414 6.66635 2.68971M18.333 10.3314C18.333 9.23703 18.1175 8.1534 17.6987 7.14235C17.2799 6.1313 16.6661 5.21265 15.8922 4.43882C15.1184 3.665 14.1998 3.05117 13.1887 2.63238C12.1777 2.21359 11.094 1.99805 9.99968 1.99805V10.3314H18.333Z",
    stroke: "#475467",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieLineChart);
export default __webpack_public_path__ + "static/media/pieLineChart.9a7bfbd0e0a8d398c130a3ffabe442c1.svg";
export { ForwardRef as ReactComponent };